import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {priceFormat} from "@pg-mono/string-utils";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {OfferPriceType} from "../../../offer/types/OfferPriceType";

interface IProps {
    twoPercentCreditAvailable?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    variant?: "tile";
    isPlansList?: boolean;
    isInPropertyConfigurator?: boolean;
    showPrice?: boolean;
    price?: number | null;
    priceType?: number | null;
    currency: string;
}

export const AskForPropertyButtonVariantBCD: React.FC<IProps> = (props) => {
    const onClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        props.onClick && props.onClick(event);
    };

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.showPrice,
        isProperty: true,
        propertyPrice: props.price,
        priceType: props.priceType,
        preferShortFormat: !props.isPlansList,
        isPropertyList: true
    });

    if (!!props.price && props.showPrice && !props.isPlansList) {
        const priceType = props.priceType === OfferPriceType.NETTO ? " netto" : "";

        return (
            <div className={priceButton}>
                <Text variant="body_copy_2" strong>
                    {priceFormat(props.price, {unit: `${props.currency}${priceType}`})}
                </Text>

                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
                    <Text variant="button_micro">{InquiryButtonTypeName.ASK}</Text>
                </Button>
            </div>
        );
    }

    return props.isPlansList || props.isInPropertyConfigurator ? (
        <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} variant="filled_primary" size="x-small" onClick={onClick} css={w100}>
            <Text variant="button_small">{buttonText}</Text>
        </Button>
    ) : (
        <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
            {buttonText}
        </Button>
    );
};

const priceButton = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    "@media screen and (min-width: 1024px)": {
        columnGap: 1,
        flexDirection: "row"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {priceFormat} from "@pg-mono/string-utils";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {getLeadButtonText} from "../../../lead/utils/get_lead_button_text";
import {OfferPriceType} from "../../../offer/types/OfferPriceType";

interface IProps {
    twoPercentCreditAvailable?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    variant?: "tile";
    isPlansList?: boolean;
    isInPropertyConfigurator?: boolean;
    showPrice?: boolean;
    price?: number | null;
    priceType?: number | null;
    currency: string;
}

export const AskForPropertyButtonVariantBCD: React.FC<IProps> = (props) => {
    const onClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        props.onClick && props.onClick(event);
    };

    const buttonText = getLeadButtonText({
        isPriceHidden: !props.showPrice,
        isProperty: true,
        propertyPrice: props.price,
        priceType: props.priceType,
        preferShortFormat: !props.isPlansList,
        isPropertyList: true
    });

    if (!!props.price && props.showPrice && !props.isPlansList) {
        const priceType = props.priceType === OfferPriceType.NETTO ? " netto" : "";

        return (
            <div className={priceButton}>
                <Text variant="body_copy_2" strong>
                    {priceFormat(props.price, {unit: `${props.currency}${priceType}`})}
                </Text>

                <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
                    <Text variant="button_micro">{InquiryButtonTypeName.ASK}</Text>
                </Button>
            </div>
        );
    }

    return props.isPlansList || props.isInPropertyConfigurator ? (
        <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} variant="filled_primary" size="x-small" onClick={onClick} css={w100}>
            <Text variant="button_small">{buttonText}</Text>
        </Button>
    ) : (
        <Button dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_LEAD_FORM_PROPERTY_BOX} onClick={onClick} variant="highlight_primary">
            {buttonText}
        </Button>
    );
};

const priceButton = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    "@media screen and (min-width: 1024px)": {
        columnGap: 1,
        flexDirection: "row"
    }
});
